import { AnchorHTMLAttributes } from "react"

import { Container } from "./_hexIconButton"

interface IHexIconButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  icon: string;
  text: string;
  to: string;
}

export const HexIconButton = ({
  icon,
  text,
  to,
  ...rest
}:IHexIconButtonProps) => {
  return (
    <Container
      to={to}
      {...rest}
    >
      <div className="hex-icon-button__icon-container">
        <img
          className="hex-icon-button__icon"
          src={icon}
          alt={text}
        />
      </div>
      <h1 className="hex-icon-button__text">
        {text}
      </h1>
    </Container>
  )
}
